import About from "./pages/About";
import Home from "./pages/Home";
import LandingPage from "./pages/LandingPage";
import Product from "./pages/Product";
import Products from "./pages/Products";
import { Route, Routes } from "react-router-dom";
import Pharmacy from "./pages/Pharmacy";
import TopNavContainer from "./containers/TopNavContainer";
import Contact from "./pages/Contact";
import CategoryPage from "./pages/Products/categoryPage";
import Service from "./pages/Service";
import OnlineStore from "./pages/OnlineStore";
import Doctors from "./pages/Doctors";
import Sustainability from "./pages/Sustainability";


function App() {
  return (
    <Routes>
      <Route path="" element={<Home />}>
        <Route path="" element={<LandingPage />} />
        <Route path="medicalsupplies" element={<Products />} />
        <Route path="" element={<TopNavContainer />}>
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="pharmacy" element={<Pharmacy />} />
          <Route path="services" element={<Service />} />
          <Route path="onlinestore" element={<OnlineStore />} />
          <Route path="doctors" element={<Doctors />} />
          <Route path="sustainability" element={<Sustainability />} />
        </Route>
        <Route path="medicalsupplies/:categoryId" element={<CategoryPage />} />
        <Route path="medicalsupplies/:categoryId/:productId">
          <Route index element={<Product />} />
          <Route path=":subId" element={<Product />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
